<div #divSpinnerModal class="cargandoModal" [style.display]="cargando ? '' : 'none'"><mat-spinner style="margin:0 auto; margin-top: 15%;" ></mat-spinner></div>

<button class="close" mat-button (click)="onNoClick()">X</button>
<p style="text-align: left;
font: normal normal bold 26px/53px Montserrat;
letter-spacing: 0px;
color: #00B09E;
opacity: 1;">Subir Medios de Verificación <i style="color: #EE366D;" *ngIf="dataJardin.etapaJardin===1" >Modo Entrenamiento</i></p> 

<mat-dialog-content> 
    <div class="row mb-3">
        <div class="col-sm-10">
            <p style="text-align: left;
            letter-spacing: 0px;
            color: #30374B;
            opacity: 1;">En esta Sección deberá subir todos los medios de verificación que avalan los puntajes asignados en su Guía de Evaluación. Considere que más adelante deberá asociar estos medios a los elementos de gestión que correspondan.</p>
        </div>
        <div class="col-sm-2">
            <img src="../../../../../../assets/icons/ico_subir-medios_lg@2x.png" class="title-pic" style="width: 110px;margin-top: -27px;position: absolute;" >
        </div>
    </div>

    <mat-accordion class="acordeon-instrucciones">
        <mat-expansion-panel  (opened)="acordeon = true" (closed)="acordeon = false" hideToggle="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    <h4>Instrucciones</h4>
                </mat-panel-title>
                <mat-panel-description>
                    <div>    
                        <img style="width: 35px;margin-top: 10px;" *ngIf="!acordeon" src="../../../.././../../assets/icons/JUNJI__green-plus.svg" >
                        <img style="width: 35px;margin-top: 10px;" *ngIf="acordeon" src="../../../.././../../assets/icons/JUNJI__green-less.svg" >
                    </div>
                </mat-panel-description>
            </mat-expansion-panel-header>
            
            <p>
                Para <b>SUBIR</b> los medios de verificación deberá seguir los siguientes pasos: 
            </p>
            <p>
                <b>Paso 1:</b> Presione el botón "Seleccionar archivo". <br>
                <b>Paso 2:</b> Busque en su computador la carpeta que contiene todos los medios de verificación digitales. <br>
                <b>Paso 3:</b> Seleccione el archivo que desea cargar.<br> 
                <b>Paso 4:</b> Presione el botón "Abrir".<br> 
                <b>Paso 5:</b> Presione "Subir".<br> 
                <b>Paso 6:</b> Revise que su medio de verificación esté cargado en la tabla "Listado de medios de verificación disponibles" 
            </p>
            <p>
                Considere que: <br>
                - Sólo podrá subir archivos como imágenes (formato jpg, gif), power point (formato ppt, pptx), word (formato doc, docx), PDF. <br>
                - Debe presionar el botón eliminar para sacar un archivo del listado de medios de verificación disponibles.
            </p>
        </mat-expansion-panel>
    </mat-accordion>

    <div class="div-file">
        <input type="file" class="fileSelect" #inputFile (change)="cambioArchivo($event)">
        <small *ngIf="archivoCargado" style="color:red;">&nbsp;&nbsp;&nbsp;&nbsp;Debe seleccionar un archivo</small>
    </div>
    <div class="button-row"> 
        <button mat-button class="btn-cancelar" (click)="cancelarArchivo()">Cancelar</button>
        <button mat-button class="btn-confirmar" (click)="subirArchivo($event)">Subir</button>
    </div>

    <mat-divider></mat-divider>

    <p style="text-align: left;
    font: normal normal bold 14px/28px Montserrat;
    letter-spacing: 0px;
    color: #4C4D55;
    text-transform: uppercase;
    opacity: 1;">Listado de medios de verificación disponibles</p>
    <div class="cargando"><mat-spinner *ngIf="cargando"></mat-spinner></div>
    <table mat-table [dataSource]="dataSource" class="mat-table medio-verificacion" *ngIf="!cargando">
        <ng-container matColumnDef="nombre"> 
            <th mat-header-cell *matHeaderCellDef> MEDIO DE VERIFICACIÓN</th>
            <td mat-cell *matCellDef="let element">{{element.nombreArchivo}}</td>
        </ng-container>
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef> ACCIONES </th>   
            <td mat-cell *matCellDef="let element"> 
                <img (click)="descargarMedio(element)" style="width: 35px;margin: 5px;cursor: pointer;" *ngIf="!acordeon" src="../../../.././../../assets/icons/JUNJI_download.svg" >
                <img (click)="eliminarMedio(element)"  style="width: 35px;margin: 5px;cursor: pointer;" *ngIf="!acordeon" src="../../../.././../../assets/icons/JUNJI_delete.svg" >
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr> 
    </table>
</mat-dialog-content>